import React, { Component} from 'react';
import { FacebookProvider, Share } from 'react-facebook';
import {FacebookShareButton} from 'react-share'

export default function ShareFunction({url,texto,children}){



    return (
        <FacebookShareButton url={url} children={children} quote={texto}></FacebookShareButton>
        // <FacebookProvider appId="1880342718894725">
        //   <Share href={url} quote={texto} appId="1880342718894725" >
        //     {({ handleClick, loading }) => (
        //       <button type="button" disabled={loading} onClick={handleClick}>Share</button>
        //     )}
        //   </Share>
        // </FacebookProvider>
      );
}



// export default class Example extends Component {
//   render(props) {
//       console.log(props)
//     return (
//       <FacebookProvider appId="1880342718894725">
//         <Share href={'teste'}>
//           {({ handleClick, loading }) => (
//             <button type="button" disabled={loading} onClick={handleClick}>Share</button>
//           )}
//         </Share>
//       </FacebookProvider>
//     );
//   }
// }
